
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/impact-report-home",
      function () {
        return require("private-next-pages/archive/impact-report-home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/impact-report-home"])
      });
    }
  